












































	import {
		Component,
		Prop,
		Vue
	} from 'vue-property-decorator';
	import {
		SrcFilter
	} from '@/mixins/Media';
	import {
		Cirus
	} from '@/classes//Http'
	import {
		Media
	} from '@/classes/TayehApi';
	import VueCropper from 'vue-cropperjs';
	import 'cropperjs/dist/cropper.css';
import { Image } from 'element-ui';
	@Component({
		mixins: [
			SrcFilter,
		],
		components: {
			VueCropper
		}
	})
	export default class UploadImage extends Vue {
		@Prop() private value: string | number;
		@Prop() private width: string | number;
		@Prop() private fontSize: string | number;
		@Prop() private can_cancel: boolean;
		@Prop({default: true}) private show_placeholder_text: boolean;
		imgSrc: string = null;
		croppedImage: Image = null;
		uploading = false;
		file: File = null;
		drag_over = false;
		loading_image = false;

		public get showImage() : boolean {
			return this.image!==null&&!this.error
		}

		drop(e: any) {
			this.drag_over = false;
			const files = e.dataTransfer.files
			const file = files[0]
			if (!this.checkFileType(file.type)) return;
			this.previewImage(file)
			// let reader = new FileReader()
			// reader.onload = f => {
			// 	let src = f.target.result
			// }
			// reader.readAsDataURL(file)
		}
		handleFileChoosed(e: any) {
			const files = e.target.files
			const file: File = files[0]
			if (!this.checkFileType(file.type)) return;
			this.previewImage(file);
			// this.upload(this.file)

		}
		handleCloseCrop() {
			this.imgSrc = null;
		}
		previewImage(file: File) {
			this.error = null;
			this.file = file;
			const url = URL.createObjectURL(this.file);
			this.imgSrc = url;
		}

		public get imageSrc(): string {
			return this.image?.url || null;
		}

		private action = `${process.env.VUE_APP_blobURL}/image`;
		private content: any;
		private image: any = null;
		private uploader_width: string | number = null;
		private uploader_font_size: string | number = null;
		private uploader_cancel = false;
		private get style() {
			return {
				width: this.uploader_width,
				height: this.uploader_width,
				"font-size": this.uploader_font_size
			}
		}
		private show_delete: any = true;
		private error = false;
		AUTH_HEADER() {
			return Cirus.AUTH_HEADER()
		}
		async getMedia() {			
			if (this.content === null) {
				this.image = null
				return;
			}
			const res = await Media.getMediaUrl(this.content);			
			this.image = res.data;
		}
		cropImage() {
			// this.loading_image = true;
			const croppedConvas: HTMLCanvasElement = (this.$refs.cropper as any).getCroppedCanvas();
			
			croppedConvas.toBlob((blob: any) => {
				const url = URL.createObjectURL(blob)
				this.image = {
					url: url,
					alt: 'تصویر آپلود شده',
				};
				blob.name = this.file.name;
				blob.filename = this.file.name;
				blob.originalname = this.file.name;
				blob.lastModified = this.file.lastModified;
				this.file = blob;
				this.image = {
					url: URL.createObjectURL(blob),
					alt: 'تصویر آپلود شده',
				};
				this.upload(this.file);
				return
			}, this.file.type, 0.9);
		}
		async upload(file: File) {
			this.uploading = true;
			this.error = false;
			this.loading_image = false;
			let formData = new FormData()
			formData.append('image', file, this.file.name)
			try {
				const res = await Media.uploadImage(file)
				this.$emit('input', res.data.media.id);
				this.$emit('update', res.data.media.id);
				this.content = res.data.id;
				this.error = false;
			} catch (err) {
				console.log(err);
			}
			this.loading_image = false;
			this.imgSrc = null;
			this.uploading = false;
		}
		// onSuccess(res: {
		// 	err ? : string,
		// 	media: any
		// }) {
		// 	if (!res.err) {
		// 		setTimeout(() => {
		// 			this.content = res.media.id;
		// 			this.$emit('input', this.content)
		// 			this.getMedia();
		// 			this.error = false;
		// 		}, 5000);
		// 	} else {
		// 		this.$message({
		// 			showClose: true,
		// 			message: res.err,
		// 			type: 'error',
		// 			duration: 10000
		// 		});
		// 	}
		// }
		handleViewError() {
			this.error = this.image!==null;
			this.loading_image=false
		}
		private cancel() {
			this.content = null;
			this.error = false;
			this.image = null;
			this.file = null;
			this.$emit('input', null);
			this.$emit('update', null);
		}
		mouseEnter() {
			this.show_delete = true;
		}
		mouseOut() {
			this.show_delete = false;
		}
		checkFileType(type: string) {
			const canUpload = type == 'image/jpeg' || type == 'image/jpg' || type == 'image/png'
			if (!canUpload) {
				this.$alert('تنها فایل ها با فرمت png و jpg قابل آپلود هستند.', {
					type: 'error',
					confirmButtonText: 'متوجه شدم'
				});
			}
			return canUpload;
		}
		created() {
			this.uploader_width = this.width;
			this.uploader_font_size = this.fontSize;
			this.uploader_cancel = this.can_cancel;
			this.content = this.value;
		}
		mounted() {
			if (!this.uploader_width) this.uploader_width = '178px';
			if (!this.uploader_font_size) this.uploader_font_size = '14px'
			if (typeof this.uploader_cancel == 'undefined') this.uploader_cancel = true;
			this.getMedia();
		}
	}
